import { OrderListprops } from "../../../../Component/Interface/Order";
import { CheckBox } from "../../../../Component/style/common_style";
import RenderMultiRows2, {
  HeaderRow,
  Row,
  Table,
  TableHeader,
} from "../../../../Component/style/orderTable_style2";

const Order_cancel = ({
  list,
  selectOrder,
  setSelectOrder,
}: OrderListprops) => {
  const setting_check_list = (seq: number) => {
    if (setSelectOrder) {
      setSelectOrder([seq]);
    }
  };

  return (
    <>
      <TableHeader $width={90}>
        <span />
        <HeaderRow>주문자</HeaderRow>
        <HeaderRow $width={6}>입금자</HeaderRow>
        <HeaderRow $width={10}>주문일시</HeaderRow>
        <HeaderRow $width={6}>상품 번호</HeaderRow>
        <HeaderRow>품목명</HeaderRow>
        <HeaderRow>옵션</HeaderRow>
        <HeaderRow>단가</HeaderRow>
        <HeaderRow $width={5}>수량</HeaderRow>
        <HeaderRow>총 금액</HeaderRow>
        <HeaderRow $width={10}>취소일시</HeaderRow>
      </TableHeader>

      {list.map((data, idx) => {
        const rowHeight = data.order_details.length || 1;

        return (
          <Table
            key={idx}
            className={idx % 2 === 0 ? "" : "x2"}
            $height={rowHeight}
            $width={90}
          >
            <span>
              <RenderMultiRows2
                detailData={data.order_details}
                searchkey={"seq_check"}
                Component={({ detail_seq }) => (
                  <CheckBox
                    type={"checkbox"}
                    className="red"
                    value={detail_seq}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                      setting_check_list(Number(e.target.value))
                    }
                    checked={selectOrder && selectOrder[0] === detail_seq}
                  />
                )}
              />
            </span>
            <Row>{data.order_name}</Row>
            <Row $width={6}>{data.order_nickname}</Row>

            {[
              { key: "주문일시", width: 10 },
              { key: "상품번호", width: 6 },
              { key: "품목명" },
              { key: "옵션" },
              { key: "단가" },
              { key: "수량", width: 5 },
            ].map(({ key, width }) => (
              <Row key={key} $width={width}>
                <RenderMultiRows2
                  detailData={data.order_details}
                  searchkey={key}
                />
              </Row>
            ))}

            {[{ key: "총 금액" }, { key: "상태변경일", width: 10 }].map(
              ({ key, width }) => (
                <Row
                  key={key}
                  $width={width}
                  className={key === "상태변경일" ? "last" : ""}
                >
                  <RenderMultiRows2
                    detailData={data.order_details}
                    searchkey={key}
                  />
                </Row>
              )
            )}
          </Table>
        );
      })}
    </>
  );
};

export default Order_cancel;
